<template>
  <div>
    <div class="custom-dialog__wrapper" v-if="dialogOrderVisible">
      <div role="dialog" aria-modal="true" aria-label="套餐" class="custom-dialog custom-dialog--center">
        <div class="custom-dialog__header">
          <span class="custom-dialog__title">{{ dialogTitle }}</span>
          <div class="custom-dialog__headerbtn">
            <i class="custom-dialog__close el-icon-circle-close" @click="close(1)"></i>
          </div>
        </div>
        <div class="custom-dialog__body">
          <div class="cus-dialog-content flex" v-if="stepNum == 1">
            <div class="cus-dialog-card" style="border-right: 1px solid #C6C9CC;padding-right: 40px;">
              <div class="cus-dialog-cloumn">
                <div class="cus-dialog-title">产品名称</div>
                <div class="flex flex-wrap">
                  <div
                    v-for="(item, index) in goodsList"
                    :key="index"
                    class="cus-dialog-item pointer"
                    :class="item.active ? 'cus-dialog-active' : ''"
                    @click="chooseProduct(index)"
                  >{{ item.name }}</div>
                </div>
              </div>
              <div class="cus-dialog-cloumn">
                <div class="cus-dialog-title">单价</div>
                <div class="flex flex-wrap">
                  <div
                    v-for="(item, index) in goodsTwoList"
                    :key="index"
                    class="cus-two-dialog-item pointer"
                    :class="item.active ? 'cus-two-dialog-active' : ''"
                    @click="chooseTwoProduct(index)"
                  >
                    <div class="mt-4">{{ item.name }}</div>
                    <div class="two-dialog-price" :class="item.active ? 'cus-two-price-active' : ''">¥{{ item.price }}/席位/年</div>
                  </div>
                </div>
              </div>
              <div class="cus-dialog-cloumn" v-if="currentGoodsItem.duration">
                <div class="cus-dialog-title">选择购买时长（{{ currentGoodsTwoItem.unit }}）</div>
                <div class="cus-dialog-number">
                  <el-input-number v-model="monthNum" @change="handleNumberChange" :min="1" :max="10" label="描述文字"></el-input-number>
                </div>
              </div>
              <div class="cus-dialog-cloumn" v-if="currentGoodsItem.position">
                <div class="cus-dialog-title">选择席位数</div>
                <div class="cus-dialog-number">
                  <el-input-number v-model="seatNum" @change="handleNumber2Change" :min="1" :max="10" label="描述文字"></el-input-number>
                </div>
              </div>
            </div>
            <div class="cus-dialog-card" style="padding-left: 40px;">
              <div class="cus-dialog-title" style="margin-bottom: 18px;">订单详情</div>
              <div>
                <div class="flex mb-4">
                  <div class="cus-gray">当前团队：</div>
                  <div class="cus-gr63ay">{{ groupInfo.groupName }}</div>
                </div>
                <div class="flex mb-4">
                  <div class="cus-gray">订购时长：</div>
                  <div class="cus-gr63ay">{{ currentGoodsTwoItem.name }}</div>
                </div>
                <div class="flex mb-4">
                  <div class="cus-gray">预期生效时间：</div>
                  <div class="cus-gr63ay">付款后立即生效</div>
                </div>
              </div>
              <div class="flex mb-4">
                <div class="cus-gray flex items-center">付款金额：</div>
                <div class="cus-red ml-2">¥{{ actualPrice }}</div>
                <div class="cus-origin-price-box">
                  <span class="price-text">原价:¥{{ totalPrice }}</span>
                  <span class="price-text ml-2">优惠:</span>
                  <span class="price-discount">¥{{ discountAmount }}</span>
                </div>
              </div>
              <!-- 我的优惠券 -->
              <div class="cus-coupon-section mb-4" v-if="couponList.length > 0">
                <div 
                  v-for="(coupon, index) in couponList" 
                  :key="coupon.id" 
                  class="cus-coupon-row flex items-center"
                >
                  <div class="cus-gray coupon-label" v-if="index === 0">我的优惠券：</div>
                  <div class="coupon-label" v-else></div>
                  <el-checkbox 
                    v-model="coupon.selected" 
                    @change="handleCouponChange(index, coupon)"
                  ></el-checkbox>
                  <div 
                    class="cus-coupon-card flex items-center"
                    :class="{ 'coupon-selected': coupon.selected }"
                  >
                    <div class="coupon-card-inner w-full relative">
                      <div class="coupon-amount">
                        <span class="currency">¥</span>
                        <span class="amount-num">{{ coupon.amount }}</span>
                      </div>
                      <div class="coupon-desc absolute">首次购买可使用</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mb-4">
                <el-button type="primary" class="w-full" @click="orderCheck()">立即下单</el-button>
              </div>
              <div class="flex items-center">
                <el-checkbox v-model="checked"></el-checkbox>
                <div class="cus-gray ml-2">我已充分阅读并同意<a class="ml-2" href="javascript:;" style="color: #0080FF;">《服务协议》</a></div>
              </div>
              <div class="cus-exchange-part">
                <div class="cus-dialog-title">兑换码兑换</div>
                <div class="flex">
                  <div class="relative flex-auto">
                    <el-input v-model="exchangeCode" placeholder="请输入内容"></el-input>
                    <span class="absolute cus-exchange-error" v-if="errState">兑换码有误，请重新输入！</span>
                  </div>
                  <div class="cus-exchange-btn" @click="exchangeConfirm">确认兑换</div>
                </div>
              </div>
            </div>
          </div>
          <div class="cus-dialog-content" v-else-if="stepNum == 2">
            <div class="cus-dialog-part" style="margin-bottom: 30px;">
              <div class="cus-dialog-cloumn">
                <div class="cus-dialog-title">订单详情</div>
                <div class="cus-dialog-info flex items-center">
                  <div class="cus-info-item flex items-center justify-end" style="width: 40%;">
                    <div class="cus-item-avatar text-center">{{ username.substring(0, 1) }}</div>
                    <div class="cus-item-pinfo">
                      <div class="cus-pinfo-name">{{ groupInfo.groupName }}</div>
                      <div class="cus-pinfo-orderN">订单编号：{{ orderInfo.code }}</div>
                    </div>
                  </div>
                  <!-- <div style="width: 1px;height: 100%;background: #C6C9CC;"></div> -->
                  <div class="cus-info-item flex justify-evenly" style="flex: auto;border-left: 1px solid #C6C9CC;">
                    <div>
                      <div class="cus-info-desc">产品信息：<span>{{ orderInfo.name }}</span></div>
                      <div class="cus-info-desc">订购时长：<span>{{ orderInfo.buyTime }}</span><span v-if="orderInfo.buyType == 1">个月</span><span v-else>年</span>
                      </div>
                      <div class="cus-info-desc mb-none">订购席位：<span>{{ orderInfo.positionCnt }}个</span></div>
                    </div>
                    <div>
                      <div class="cus-info-desc">生效时间：<span>付款后立即生效</span></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="cus-dialog-part">
              <div class="cus-dialog-cloumn">
                <div class="cus-dialog-title">支付方式</div>
                <div class="cus-dialog-pays flex">
                  <div class="qrcode" ref="qrCodeUrl">
                    <!-- <vue-qr :logoSrc="logoUrl" :text="messageText" :logoScale="50" :size="130" :margin="0"></vue-qr> -->
                    <img class="w-full" :src="imgQrCode">
                  </div>
                  <div class="pays-payinfo">
                    <div class="payinfo-price flex items-center">
                      <span class="payinfo-label">应付金额：</span>
                      <span class="payinfo-amount">¥{{ orderInfo.money }}</span>
                      <div class="cus-origin-price-box">
                        <span class="price-text">原价:¥{{ orderInfo.originalAmount || totalPrice }}</span>
                        <span class="price-text ml-2">优惠:</span>
                        <span class="price-discount">¥{{ orderInfo.discountAmount || discountAmount }}</span>
                      </div>
                    </div>
                    <div class="payinfo-paytype flex">
                      <div
                        class="payinfo-tag flex justify-center align-center pointer"
                        :class="payType == 'WeChat' ? 'filterNone' : ''"
                        @click="selectPayTypes('WeChat')"
                      >
                        <img src="@/assets/img/wechat.svg" class="filter" />
                        <span>微信支付</span>
                      </div>
                      <div
                        class="payinfo-tag flex justify-center align-center pointer"
                        :class="payType == 'Alipay' ? 'filterNone' : ''"
                        @click="selectPayTypes('Alipay')"
                      >
                        <img src="@/assets/img/Alipay.svg" class="filter" />
                        <span>支付宝</span>
                      </div>
                    </div>
                    <div class="payinfo-desc">
                      请您在今天
                      <span v-if="orderType == 3">{{ formattedTime }}</span>
                      <span v-else>
                        <span id="hours">{{ hours }}</span>:<span id="minutes">{{ minutes }}</span>分
                      </span>
                      之前完成支付，否则订单将自动取消
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- stepNum=3 支付成功页面 -->
          <div class="cus-dialog-content" v-else-if="stepNum == 3">
            <div class="pay-success-container">
              <div class="pay-success-box">
                <div class="success-icon">
                  <i class="el-icon-check"></i>
                </div>
                <div class="success-title">支付成功</div>
                <div class="success-desc">可在"订单管理"中查看订单详情！</div>
              </div>
            </div>
            <div class="coupon-gift-section" v-if="isFirstBuy">
              <div class="coupon-gift-title">系统送了您一张优惠券！快去使用吧！</div>
              <div class="coupon-gift-card" @click="handleUseCoupon(coupon)">
                <div class="gift-card-left">
                  <div class="gift-amount">¥{{ giftCoupon.amount }}</div>
                  <div class="gift-type">一年满减券</div>
                  <div class="gift-expire">失效时间：{{ giftCoupon.expirationTime.split(' ')[0] || '' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="custom-dialog__footer"></div> -->
      </div>
    </div>
    <div class="custom-dialog__wrapper" v-if="dialogTableVisible">
      <div class="custom2-dialog">
        <div class="custom2-dialog__header">
          <span class="custom2-dialog__title">席位设置</span>
          <div class="custom2-dialog__headerbtn cursor-pointer" @click="dialogTableVisible = false">x</div>
        </div>
        <div class="custom2-dialog__body"> 
          <div class="custom2-dialog-tag flex justify-between">
            <div>当前已分配席位数<span>{{ checkData.length }}</span>个</div>
            <el-input size="small" v-model="keyword" prefix-icon="el-icon-search" style="width: 240px" placeholder="搜索用户姓名" @input="getPositionTableList"></el-input>
          </div>
          <div>
            <el-table :data="gridData" :header-cell-style="{ background: '#F7F7F7 !important' ,color:'#909399  !important'}">
              <el-table-column property="userName" label="姓名"></el-table-column>
              <el-table-column property="phone" label="账号"></el-table-column>
              <el-table-column property="groupRoleName" label="团队角色"></el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <el-checkbox v-model="scope.row.collaborate" @change="checkboxChange(scope.$index, scope.row)"></el-checkbox>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination layout="prev, pager, next" :total="listQuery.total"></el-pagination>
          </div>
        </div>
        <div class="custom-dialog__footer">
          <span class="dialog-footer">
            <el-button size="medium" @click="confirmTableCancel">取消</el-button>
            <el-button size="medium" type="primary" @click="confirmTableSubmit">确定</el-button>
          </span>
        </div>
      </div>
    </div>

    <div class="custom-message-box__wrapper" v-if="dialogMsgVisible">
      <div class="el-message-box">
        <div class="el-message-box__header">
          <div class="el-message-box__title">
            <span>提示</span>
          </div>
        </div>
        <div class="el-message-box__content">
          <div class="el-message-box__container">
            <div class="el-message-box__status el-icon-warning"></div>
            <div class="el-message-box__message">
              <div>
                <div class="message-box-content mb-4">
                  <div class="content-part flex items-center" style="border-bottom: 1px solid #DADFE4;">
                    <div class="content-item con-1-item flex items-center justify-around">
                      <div class="content-span1">使用中版本</div>
                      <div class="content-span2">剩余时间：{{ currentVersion.remainTime }}</div>
                    </div>
                    <div class="content-item con-2-item flex items-center justify-around">
                      <span class="content-span3">/</span>
                      <span class="content-span4">席位：{{ currentVersion.position }}</span>
                    </div>
                  </div>
                  <div class="content-part flex items-center">
                    <div class="content-item con-1-item flex items-center justify-around">
                      <div class="content-span1">更换后版本</div>
                      <div class="content-span2">版本周期：{{ newVersion.position }}</div>
                    </div>
                    <div class="content-item con-2-item flex items-center justify-around">
                      <span class="content-span3">/</span>
                      <span class="content-span4">席位：{{ newVersion.position }}</span>
                    </div>
                  </div>
                </div>
                <div class="message-box-footer">
                  <span class="footer-span1">更换后立即生效！</span>
                  <span class="footer-span2">（当前使用中版本价值大于更换后的版本价值）</span>
                  <span class="footer-span3">确定要更换版本吗？</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="el-message-box__btns">
          <button type="button" class="el-button el-button--default el-button--small " @click="confirmMessageCancel">
            <span>关闭</span>
          </button>
          <button type="button" class="el-button el-button--default el-button--small el-button--primary " @click="confirmMessageSubmit">
            <span>更换</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { posts, gets } from "@/utils/http.js";
import { imageOssUrl } from "@/utils/services.js";
export default {
  props: {
    // dialogVisible: {
    //   type: Boolean,
    //   default: false
    // },
    dialogVisible: {
      type: Number,
      default: 0
    },
    orderItemInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      username: '',
      groupInfo: {},
      dialogOrderVisible: false,
      stepNum: 1,
      dialogTitle: '选择套餐',
      goodsList: [],
      goodsTwoList: [
        {
          name: '1个月',
          price: '',
          unit: '月',
          unitId: 1,
          active: false
        },
        {
          name: '1年',
          price: '',
          unit: '年',
          unitId: 2,
          active: false
        }
      ],
      currentGoodsItem: {
        duration: false,
        position: false
      },
      currentGoodsTwoItem: {
        name: '',
        unit: '月',
        unitId: 1
      },
      monthNum: 1, //购买时长
      seatNum: 1, //购买席位数
      totalPrice: 0,
      checked: false,
      exchangeCode: '',
      orderInfo: {},
      payType: 'WeChat',
      errState: false,
      dialogTableVisible: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 100
      },
      gridData: [],
      checkData: [],
      keyword: '',
      hours: 23,
      minutes: 59,
      nowTime: "",
      leftTime: 24 * 60 * 60,
      h: null,
      m: null,
      timer: '',
      imgQrCode: '',
      orderType: 0, //1-正常下单，2-版本升级, 3-立即支付
      dialogMsgVisible: false,
      currentVersion: {},
      newVersion: {},
      couponList: [], // 优惠券列表
      selectedCoupon: null, // 当前选中的优惠券
      isFirstBuy: false, // 是否是首次购买
      giftCoupon: {} // 赠送的优惠券
    };
  },
  computed: {
    formattedTime() {
      return this.orderItemInfo.xcsj.hh + ':' + this.orderItemInfo.xcsj.mm + '分'
    },
    // 优惠金额
    discountAmount() {
      if (this.selectedCoupon) {
        return Number(this.selectedCoupon.amount).toFixed(2)
      }
      return '0.00'
    },
    // 实际支付价格
    actualPrice() {
      const discount = this.selectedCoupon ? Number(this.selectedCoupon.amount) : 0
      const actual = Number(this.totalPrice) - discount
      // 当实际支付价格小于等于0时，一律返回0.00
      return actual <= 0 ? '0.00' : actual.toFixed(2)
    }
  },
  watch: {
    dialogVisible(newVal, oldVal) {
      console.log('newVal============>', newVal)
      console.log('oldVal============>', oldVal)
      this.orderType = newVal
      if (newVal) this.inits()
    }
  },
  created() {
    // this.groupInfo = JSON.parse(sessionStorage.getItem("groupInfo"))
    this.username = sessionStorage.getItem("loginPhone")
  },
  methods: {
    inits () {
      const that = this
      that.groupInfo = JSON.parse(sessionStorage.getItem("groupInfo"))
      if (that.timer) clearInterval(that.timer)
      // 获取优惠券列表
      that.getCouponList()
      if (that.orderType == 3) {
        gets(`/order/getOnlineOrderById/${that.orderItemInfo.id}`).then((res) => {
          console.log(res)
          if (res.code == 200) {
            that.orderInfo = res.data
            that.orderInfo.wxQrCode = that.orderInfo.wxQrCode.replace('/oss', imageOssUrl)
            that.imgQrCode = that.orderInfo.wxQrCode
            that.timer = setInterval(() => {
              that.checkWxPayStatus()
            }, 1000)
            that.stepNum = 2
            that.dialogOrderVisible = true
          }
        })
      }
      else {
        gets('/productPackage/onlineOrdersList').then((res) => {
          console.log(res)
          if (res.code == 200) {
            that.goodsList = res.data.length > 0 ? res.data : []
            if (res.data.length > 0) {
              that.goodsList.forEach(item => {
                item.active = false
              })
              that.currentGoodsItem = that.goodsList[0] //当前选择的产品
              that.goodsList[0].active = true
              that.goodsTwoList[0].price = that.goodsList[0].monthPrice
              that.goodsTwoList[0].active = true
              that.goodsTwoList[1].price = that.goodsList[0].yearPrice
              that.goodsTwoList[1].active = false
              that.currentGoodsTwoItem = that.goodsTwoList[0] //当前选择的单价
              if (that.orderType == 1) that.totalPrice = Number(that.goodsList[0].monthPrice) * that.monthNum * that.seatNum //总金额
              else that.getCost(1)
            }
            that.dialogOrderVisible = that.goodsList.length > 0 ? true : false
          }
        })
      }
    },
    getCost (type) {
      const that = this
      const query = {}
      query.groupId = that.groupInfo.id
      query.productPackageId = that.currentGoodsItem.id
      query.buyType = that.currentGoodsTwoItem.unitId
      query.buyTime = that.monthNum
      query.positionCnt = that.seatNum
      gets('/order/getUpgradeCost', query).then((res) => {
        console.log(res)
        if (res.code == 200) {
          that.totalPrice = res.data.cost ? Number(res.data.cost) : Number(that.currentGoodsItem.monthPrice) * that.monthNum * that.seatNum //总金额
          if (type == 2) {
            if (res.data.isRelegate) {
              that.currentVersion = res.data.currentVersion
              that.newVersion = res.data.newVersion
              that.dialogMsgVisible = true
            }
            else {
              that.orderExistOnlineCheck()
            }
          }
        }
      })
    },
    reset () {
      this.dialogOrderVisible = false
      this.stepNum = 1
      this.monthNum = 1
      this.seatNum = 1
      this.checked = false
      this.orderInfo = {}
      this.totalPrice = 0
      this.exchangeCode = ''
      this.payType = 'WeChat'
      this.errState = false
      this.couponList = []
      this.selectedCoupon = null
      this.giftCoupon = null
      this.isFirstBuy = false
      if (this.timer) clearInterval(this.timer)
    },
    close (n) {
      this.reset()
      this.$emit('close', n)
    },
    handleNumberChange (val) {
      console.log(val)
      if (this.orderType == 1) this.totalPrice = Number(this.currentGoodsTwoItem.price) * Number(val) * Number(this.seatNum)
      else this.getCost(1)
    },
    handleNumber2Change (val) {
      console.log(val)
      if (this.orderType == 1) this.totalPrice = Number(this.currentGoodsTwoItem.price) * Number(this.monthNum) * Number(val)
      else this.getCost(1)
    },
    chooseProduct (i) {
      console.log(i)
      const that = this
      that.goodsList.forEach(item => {
        item.active = false
      })
      // that.$set(that.goodsList, 'active', true)
      that.goodsList[i].active = true
      // 序列化与反序列化
      that.goodsList = JSON.parse(JSON.stringify(that.goodsList))


      that.currentGoodsItem = that.goodsList[i] //当前选择的产品
      that.goodsTwoList[0].price = that.goodsList[i].monthPrice
      that.goodsTwoList[0].active = true
      that.goodsTwoList[1].price = that.goodsList[i].yearPrice
      that.goodsTwoList[1].active = false
      that.currentGoodsTwoItem = that.goodsTwoList[0] //当前选择的单价
      if (that.orderType == 1) that.totalPrice = Number(that.goodsList[i].monthPrice) * Number(that.monthNum) * Number(that.seatNum) //总金额
      else that.getCost(1)

    },
    chooseTwoProduct (i) {
      console.log(i)
      this.goodsTwoList.forEach(item => {
        item.active = false
      })
      this.goodsTwoList[i].active = true
      this.currentGoodsTwoItem = this.goodsTwoList[i]
      if (this.orderType == 1) this.totalPrice = Number(this.goodsTwoList[i].price) * Number(this.monthNum) * Number(this.seatNum)
      else this.getCost(1)
    }, 
    exchangeConfirm() {
      const that = this
      that.$confirm('确认要使用兑换码进行兑换吗？', '确认兑换', {
          confirmButtonText: '兑换',
          cancelButtonText: '关闭',
          type: 'warning'
        }).then(() => {
          const query = {}
          query.coopSysGroup = {}
          query.coopSysGroup.id = that.groupInfo.id
          query.exchangeCode = that.exchangeCode
          posts('/order/exchange', query).then((res) => {
            if (res.code == 200) {
              that.$message({
                type: 'success',
                message: '兑换成功!'
              })
              that.close(2)
            }
            else {
              that.errState = true
            }
          })
        }).catch(() => {
          console.log('已取消')         
        })
    },
    orderCheck() {
      const that = this
      if (!that.checked) {
        that.$message({
          type: 'error',
          message: '请阅读并同意服务协议'
        })
        return
      }
      that.orderType == 2 ? that.getCost(2) : that.orderExistOnlineCheck()
    },
    orderExistOnlineCheck() {
      const that = this
      gets(`/order/isExistOnlineOrder/${that.groupInfo.id}`).then((res) => {
          console.log(res)
          if (res.data) {
            that.orderExistPositionCheck()
          }
          else {
            that.$confirm('当前已有一个未完成订单，暂时不能进行其他付费服务，请先付款或取消订单。', '提交失败', {
              confirmButtonText: '查看订单',
              showCancelButton: false,
              type: 'warning'
            }).then(() => {
              that.close(1)
              that.$router.push("/orderAdmin")
            })
            .catch(() => {
              console.log('已关闭')       
            })
          }
        })
    },
    orderExistPositionCheck() {
      const that = this
      posts('/order/isExistPosition', { groupId: that.groupInfo.id, positionCnt: that.seatNum }).then((res) => {
        console.log(res)
        if (res.data) {
          that.orderCreate()
        }
        else {
          that.$confirm('版本更改后的席位，少于当前版本席位数，请按需更改席位设置后，重新更换版本！', '提交失败', {
            confirmButtonText: '去设置席位',
            cancelButtonText: '关闭',
            type: 'warning'
          }).then(() => {
            that.dialogTableVisible = true
            that.getPositionTableList()
          })
          .catch(() => {
            console.log('已关闭')       
          })
        }
      })
    },
    orderCreate() {
      const that = this
      const query = {}
      query.productPackageId = that.currentGoodsItem.id
      query.positionCnt = that.seatNum
      query.buyTime = that.monthNum
      query.buyType = that.currentGoodsTwoItem.unitId
      query.payAmount = Number(that.actualPrice) // 实际支付金额（扣除优惠券后）
      query.originalAmount = that.totalPrice // 原价
      query.discountAmount = Number(that.discountAmount) // 优惠金额
      query.coopSysGroup = {}
      query.coopSysGroup.id = that.groupInfo.id
      query.coopSysGroup.groupName = that.groupInfo.groupName
      query.couponId = that.selectedCoupon ? that.selectedCoupon.id : '' // 优惠券ID
      posts('/order/createOnlineOrder', query).then((res) => {
        console.log(res)
        if (res.code == 200) {
          // 当实际支付金额小于等于0时，直接显示订单创建成功
          if (Number(that.actualPrice) <= 0) {
            that.$message({
              type: 'success',
              message: '订单创建成功！'
            })
            that.close(1)
          }
          else {
            that.orderInfo = res.data
            that.orderInfo.wxQrCode = that.orderInfo.wxQrCode.replace('/oss', imageOssUrl)
            that.imgQrCode = that.orderInfo.wxQrCode
            that.countTime()
            that.timer = setInterval(() => {
              that.checkWxPayStatus()
            }, 1000)
            that.stepNum = 2
          }
        }
        else {
          that.$notify.error({
            title: "创建失败",
            message: res.msg,
            duration: 2000
          })
        }
      })
    },
    countTime() {
      if (this.leftTime > 0) {
        this.h = Math.floor((this.leftTime / 60 / 60) % 24)
        this.m = Math.floor((this.leftTime / 60) % 60)
      }
      if (this.h < 10) {
        this.h = "0" + this.h
      }
      if (this.m < 10) {
        this.m = "0" + this.m
      }
      this.hours = this.h
      this.minutes = this.m
      if (this.leftTime <= 0) {
        this.leftTime = 24 * 60 * 60
      }
      this.leftTime--
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000)
    },
    checkWxPayStatus() {
      const that = this
      gets(`/sys/wxpay/queryBindStatus/${that.orderInfo.code}`).then((res) => {
        console.log(res)
        if (res.data == 'Finial') {
          clearInterval(that.timer)
          that.goToPaySuccess()
        }
      })
    },
    selectPayTypes(type) {
      const that = this
      that.payType = type
      clearInterval(that.timer)
      if (type == 'WeChat') {
        that.imgQrCode = that.orderInfo.wxQrCode
        that.timer = setInterval(() => {
          that.checkWxPayStatus()
        }, 1000)
      }
      else {
        that.imgQrCode = ''
        that.setPayAli()
        that.timer = setInterval(() => {
          that.checkAliPayStatus()
        }, 1000)
      }
    },
    setPayAli() {
      const query = {}
      query.outTradeNo = this.orderInfo.code
      query.totalAmount = this.orderInfo.money
      query.subject = this.orderInfo.name
      gets('/sys/alipay/pay', query).then((res) => {
        console.log(res)
        var form = res.data
        const div = document.createElement('div')  //创建div
        div.innerHTML = form  //此处form就是后台返回接收到的数据
        document.body.appendChild(div) //document.forms[0].submit()
        document.forms[0].acceptCharset='utf-8';
        document.forms[0].setAttribute('target', '_blank') 
        document.forms[0].submit()
        div.remove()
      })
    },
    checkAliPayStatus() {
      const that = this
      gets(`/sys/alipay/queryBindStatus/${that.orderInfo.code}`).then((res) => {
        console.log(res)
        if (res.data == 'Finial') {
          clearInterval(that.timer)
          that.goToPaySuccess()
        }
      })
    },
    getPositionTableList() {
      const that = this
      const query = {}
      query.groupId = that.groupInfo.id
      query.pageNumber = that.listQuery.pageNumber
      query.pageSize = that.listQuery.pageSize
      query.userName = that.keyword
      gets('/sys/coopSysGroup/groupPositionList', query).then((res) => {
        console.log(res)
        if (res.code == 200) {
          that.gridData = res.data.records
          that.listQuery.total = res.data.total
          that.checkData = res.data.records.filter(item => {
            return item.collaborate
          })
        }
      })
    },
    checkboxChange(a, b) {
      console.log(a, b)
      this.checkData = this.gridData.filter(item => {
        return item.collaborate
      })
    },
    confirmTableCancel() {
      this.dialogTableVisible = false
      this.keyword = ''
    },
    confirmTableSubmit() {
      const that = this
      const query = {}
      query.groupId = that.groupInfo.id
      query.editIdList = that.checkData.map(item => {
        return item.id
      })
      console.log(query)
      posts('/sys/coopSysGroup/batchEditGroupPosition', query).then((res) => {
        console.log(res)
        if (res.code == 200) {
          that.$message({
            type: 'success',
            message: '设置成功!'
          })
          that.confirmTableCancel
        }
        else {
          that.$notify.error({
            title: "设置失败",
            message: res.msg,
            duration: 2000
          })
        }
      })
    },
    confirmMessageCancel() {
      this.dialogMsgVisible = false
      this.currentVersion = {}
      this.newVersion = {}
    },
    confirmMessageSubmit() {
      this.dialogMsgVisible = false
      this.orderExistOnlineCheck()
    },
    // 获取优惠券列表
    getCouponList() {
      const that = this
      gets('/yzlCoupon/unusedCouponList', { userId: sessionStorage.getItem('accountID') }).then((res) => {
        console.log('优惠券列表:', res)
        if (res.code == 200 && res.data) {
          that.couponList = res.data.map(item => ({
            ...item,
            selected: false
          }))
        }
        else {
          that.$message.error(res.msg)
        }
      })
    },
    // 处理优惠券选择变化
    handleCouponChange(index, coupon) {
      const that = this
      // 单选逻辑：取消其他优惠券的选中状态
      that.couponList.forEach((item, i) => {
        if (i !== index) {
          item.selected = false
        }
      })
      // 更新选中的优惠券
      if (coupon.selected) {
        that.selectedCoupon = coupon
      } else {
        that.selectedCoupon = null
      }
    },
    // 跳转到支付成功页面
    goToPaySuccess() {
      const that = this
      that.dialogTitle = '支付成功'
      that.stepNum = 3
      posts('/yzlCoupon/isFirstBuy', { groupId: this.groupInfo.id, userId: sessionStorage.getItem('accountID') || '' }).then(res => {
        if (res.code === 200) {
          that.isFirstBuy = res.data.flag
          that.giftCoupon = res.data.yzlCoupon ? res.data.yzlCoupon : {}
        }
      })
    },
    // 立即使用优惠券
    handleUseCoupon() {
      this.close(2)
      // 可以跳转到相关页面或执行其他操作
    }
  },
};
</script>

<style lang="less" scoped>
.custom-dialog__wrapper {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: auto;
  margin: 0;
  z-index: 2000;
  background: rgba(50, 50, 51, 0.6);
}
.custom-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 52%;
  max-height: calc(100% - 30px);
  max-width: 1000px;
  min-width: 860px;
  border-radius: 10px;
  border: 1px solid #666666;
  background: #FAFAFA;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  box-sizing: border-box;
  color: #ffffff;
}
.custom2-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 42%;
  max-height: calc(100% - 30px);
  max-width: 840px;
  min-width: 700px;
  border-radius: 10px;
  background: #FAFAFA;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  box-sizing: border-box;
}
.custom3-dialog {
  position: relative;
  display: flex;
  flex-direction: column;
  margin: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 42%;
  max-height: calc(100% - 30px);
  max-width: 840px;
  min-width: 700px;
  border-radius: 10px;
  background: #FAFAFA;
  box-shadow: 0 1px 3px rgba(0,0,0,.3);
  box-sizing: border-box;
}
.custom-dialog--center {
  // text-align: center;
}
.custom-dialog__header {
  position: relative;
  font-size: 20px;
  height: 90px;
  line-height: 90px;
  background: linear-gradient( 270deg, #3DA4FE 0%, #2278EB 100%);
  color: #ffffff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 0 24px;
}
.custom2-dialog__header {
  position: relative;
  font-size: 16px;
  height: 44px;
  line-height: 44px;
  background: #F6F6F6;
  color: #1D2129;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  text-align: center;
}
.custom-dialog__headerbtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  right: 24px;
}
.custom-dialog__close {
  font-size: 22px;
  font-weight: 800;
  box-sizing: border-box;
  color: #ffffff;
  transition: all .3s;
}
.custom-dialog__close:hover {
  transform: rotate(90deg);
  transition: all .3s;
  cursor: pointer;
}
.custom2-dialog__headerbtn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  font-size: 22px;
  right: 24px;
  color: #4E5969;
}
.custom-dialog__body {
  padding: 38px 40px 24px 40px;
  background: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.custom2-dialog__body {
  padding: 16px;
  background: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.custom-dialog__footer {
  height: 54px;
  line-height: 54px;
  padding: 0 20px;
  border-top: 1px solid #E8E8E8;
  text-align: right;
  box-sizing: border-box;
}
.cus-dialog-content {
  width: 100%;
}
.cus-dialog-card {
  width: calc((100% - 1px) / 2);
}


.cus-dialog-cloumn {
  font-size: 20px;
  font-weight: 600;
  color: #323233;
}
.cus-dialog-title {
  color: #323233;
  margin-bottom: 10px;
}
.cus-dialog-item {
  width: calc((100% - 28px) / 2);
  height: 62px;
  line-height: 60px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #C6C9CC;
  color: #636566;
  margin-bottom: 20px;
  margin-right: 24px;
  &:nth-child(2n) {
    margin-right: 0;
  }
}
.cus-dialog-active {
  border-color: #0080FF;
  color: #0080FF;
}
.cus-two-dialog-item {
  width: calc((100% - 28px) / 2);
  height: 86px;
  text-align: center;
  border-radius: 10px;
  border: 1px solid #C6C9CC;
  color: #636566;
  margin-bottom: 20px;
  margin-right: 24px;
  &:nth-child(2n) {
    margin-right: 0;
  }
}
.cus-two-dialog-active {
  border-color: #0080FF;
  color: #0080FF;
}
.two-dialog-price {
  display: inline;
  padding: 3px 8px;
  background: #F2F3F5;
  border-radius: 14px;
  font-size: 12px;
  color: #86909C;
}
.cus-two-price-active {
  background: #0080FF;
  color: #ffffff;
}
.cus-dialog-number {
  margin-bottom: 20px;
}
.cus-dialog-number:last-child {
  margin-bottom: 12px;
}


.cus-gray {
  min-width: 70px;
  color: #86909C;
}
.mb-4 {
  margin-bottom: 16px;
}
.cus-gr63ay {
  color: #636466;
}
.mb-8 {
  margin-bottom: 32px;
}
.cus-red {
  color: #F85555;
  font-size: 32px;
}
.ml-2 {
  margin-left: 8px;
}
a {
  text-decoration: none;
}
.cus-exchange-part {
  background: #F2F3F5;
  border-radius: 4px;
  padding: 16px 16px 32px 16px;
  margin-top: 44px;
}
.cus-exchange-error {
  color: #F14747;
  font-size: 12px;
  left: 0;
  bottom: -16px;
}
.cus-exchange-btn {
  background: #C9E5FF;
  border-radius: 4px;
  color: #0084FF;
  font-size: 12px;
  width: 88px;
  text-align: center;
  height: 40px;
  line-height: 40px;
  margin-left: 12px;
  cursor: pointer;
}
.cus-exchange-btn:hover {
  opacity: 0.6;
}



.cus-dialog-info {
  background: #F2F3F5;
  border-radius: 4px;
  padding: 29px 0 25px 0;
}
.cus-item-avatar {
  width: 48px;
  height: 48px;
  line-height: 48px;
  border-radius: 50%;
  background: #0080ff;
  font-size: 14px;
  color: #ffffff;
  margin-left: 3%;
}
.cus-item-pinfo {
  max-width: 55%;
  margin-left: 3%;
  margin-right: 16%;
}
.cus-pinfo-name {
  font-size: 16px;
  color: rgba(50, 50, 51, 0.8);
  overflow-wrap: break-word;
}
.cus-pinfo-orderN {
  font-size: 12px;
  color: #86909C;
}
.cus-info-desc {
  font-size: 14px;
  color: #86909C;
  padding-bottom: 10px;
  span {
    color: rgba(50, 50, 51, 0.8);
  }
}
.mb-none {
  padding-bottom: 0;
}


.cus-dialog-pays {
  .qrcode {
    width: 178px;
    height: 178px;
    border: 1px dashed #e9e9e9;
  }
  .pays-payinfo {
    padding-left: 20px;
    padding-top: 10px;
    flex-direction: column;
    justify-content: space-around;
    .payinfo-price {
      font-size: 16px;
      font-family: PingFang SC-Light;
      font-weight: 300;
      color: rgba(50, 50, 51, 0.8);
      .payinfo-label {
        font-size: 16px;
        color: rgba(50, 50, 51, 0.8);
      }
      .payinfo-amount {
        font-size: 28px;
        font-family: PingFang SC-Medium;
        font-weight: 500;
        color: #ec1717;
      }
    }
    .payinfo-tag {
      width: 102px;
      height: 32px;
      font-size: 12px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4);
      border: 1px solid rgba(0, 0, 0, 0.15);
      border-radius: 2px;
      margin: 30px 30px 30px 0;
      img {
        width: 18px;
        height: 18px;
        margin-right: 7px;
      }
    }
    .payinfo-desc {
      font-size: 12px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.8);
      span {
        color: #f01b1b;
      }
    }
    .filterNone {
      background: #D8E6F3;
      border-color: #0080FF;
      color: #0080FF;
    }
  }
  .pays-public {
    margin-left: 153px;
    padding: 25px 0 25px 34px;
    border-left: 1px solid #ededed;
    margin-top: 10px;
    .public-title {
      align-items: center;
      img {
        padding-right: 10px;
      }
    }
    .public-desc {
      font-size: 12px;
      font-family: Microsoft YaHei-Regular;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.4);
      padding: 11px 0;
    }
    .public-btn {
      width: 227px;
      text-align: center;
      line-height: 38px;
      border-radius: 2px;
      border: 1px solid #d1d0d0;
      font-size: 14px;
      font-family: PingFang SC-Regular;
      font-weight: 400;
      color: #000000;
    }
  }
}


.custom2-dialog-tag {
  height: 46px;
  line-height: 46px;
  background: #F2F3F5;
  border-radius: 4px;
  color: #000000;
  font-size: 14px;
  padding-left: 16px;
  padding-right: 16px;
  margin-bottom: 16px;
  span {
    color: #0080FF;
    margin: 0 4px;
  }
}


.custom-message-box__wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  text-align: center;
  background: rgba(50, 50, 51, 0.6);
  z-index: 2002;
}
.custom-message-box__wrapper::after {
  content: '';
  display: inline-block;
  height: 100%;
  width: 0;
  vertical-align: middle;
}
.message-box-content {
  background-color: #f2f3f5;
}
.content-part {
  height: 40px;
  line-height: 40px;
  font-size: 12px;
}
.con-1-item {
  width: 65%;
}
.con-2-item {
  width: 35%;
}
.content-span1 {
  height: 20px;
  line-height: 20px;
  color: #1890FF;
  padding: 0 5px;
  background: #E0E3E9;
  border-radius: 4px;
}
.content-span2 {
  width: 90px;
}
.content-span4 {
  width: 60px;
}
.message-box-footer {
  font-size: 14px;
}
.footer-span1 {
  color: #FAAD14;
}
.footer-span2 {
  color: #A8ABB2;
}
.footer-span3 {
  color: rgba(0, 0, 0, 0.65);
}

/* 原价优惠样式 */
.cus-origin-price-box {
  position: relative;
  display: inline-flex;
  align-items: center;
  height: 32px;
  padding: 0 10px;
  background: #EAEAEA;
  border-radius: 2px;
  font-weight: 600;
  font-size: 14px;
  color: #86909C;
  margin-left: 12px;
  &::after {
    content: '';
    position: absolute;
    left: 10px;
    right: 10px;
    top: 50%;
    height: 1px;
    background: #86909C;
  }
}

/* 优惠券区域样式 */
.cus-coupon-section {
  margin-top: 8px;
}
.cus-coupon-row {
  margin-bottom: 10px;
  &:last-child {
    margin-bottom: 0;
  }
}
.coupon-label {
  width: 90px;
  flex-shrink: 0;
}
.cus-coupon-card {
  width: 246px;
  height: 40px;
  background: url('@/assets/img/globalOrder/coupon-icon.svg') no-repeat center center;
  background-size: 100% 100%;
  transition: all 0.3s;
  cursor: pointer;
  margin-left: 12px;
  border: none;
}
.coupon-selected {
  background: url('@/assets/img/globalOrder/coupon-icon-ed.svg') no-repeat center center;
  background-size: 100% 100%;
}
.coupon-card-inner {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 100%;
}
.coupon-amount {
  font-weight: 600;
  color: #636466;
  display: flex;
  align-items: baseline;
  .currency {
    font-size: 14px;
  }
  .amount-num {
    font-size: 20px;
  }
}
.coupon-selected .coupon-amount {
  font-weight: 400;
  color: #0084FF;
}
.coupon-desc {
  font-size: 12px;
  font-weight: 400;
  color: #86909C;
  right: 32px;
}
.coupon-selected .coupon-desc {
  color: #0084FF;
}

/* 支付成功页面样式 */
.pay-success-container {
  background: #F7F8FA;
  border-radius: 8px;
  padding: 40px 0;
  margin-bottom: 30px;
}
.pay-success-box {
  text-align: center;
}
.success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  background: #52C41A;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  i {
    font-size: 36px;
    color: #fff;
    font-weight: bold;
  }
}
.success-title {
  font-size: 20px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 8px;
}
.success-desc {
  font-size: 14px;
  color: #86909C;
}

/* 优惠券赠送区域 */
.coupon-gift-section {
  text-align: center;
}
.coupon-gift-title {
  font-size: 18px;
  font-weight: 600;
  color: #323233;
  margin-bottom: 20px;
}
.coupon-gift-card {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  min-width: 320px;
  height: 82px;
  background: url('@/assets/img/globalOrder/coupon-tag1.svg') no-repeat center center;
  background-size: 100% 100%;
  padding: 0;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s;
  &:hover {
    transform: scale(1.02);
  }
}
.gift-card-left {
  width: 190px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  margin: 0 auto;
}
.gift-amount {
  font-size: 24px;
  font-weight: 600;
  color: #85582D;
  display: flex;
  align-items: baseline;
  justify-content: center;
}
.gift-type {
  font-size: 12px;
  font-weight: 400;
  color: #85582D;
  margin-top: 2px;
}
.gift-expire {
  font-size: 10px;
  font-weight: 400;
  color: #C39B75;
  margin-top: 2px;
}
</style>
<style>

</style>
